import axios from 'axios';
import * as constants from '../constants';

class TenantApiService {

    static AuthenticatedApi = axios.create({
        baseURL: constants.Api.baseUri,
        // will inject auth header on-demand later as needed.
        headers: { 
            'Content-Type': 'application/json',
        }
    });

    static GetAccountPermission(token) {
        return this.AuthenticatedApi.get('/Tenant/GetAccountPermission/', {
            headers: {
                Authorization: 'Bearer ' + token
            }
        })
        .then((response) => {
            if (response.data)
                return response.data;
            else
                return null;
        })
        .catch((error) => {
            console.log('TenantApiService.GetAccountPermission() - An error has occurred calling the web api: ' + error);
            return null;
        });
    }

}

export default TenantApiService;